const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export async function apiFetch(path, options = {}) {
  const token = localStorage.getItem('authToken');
  const headers = {
    'Content-Type': 'application/json',
    ...(token && { Authorization: `Bearer ${token}` }),
    ...options.headers,
  };

  let res;
  try {
    res = await fetch(`${BASE_URL}${path}`, { ...options, headers });
  } catch (err) {
    if (err.name === 'AbortError') throw err;
    const networkError = new Error('Network error. Please check your connection.');
    networkError.isNetwork = true;
    throw networkError;
  }

  // Handle token expiration — clear all auth state and redirect to the right login
  if (res.status === 401) {
    [
      'authToken', 'userRole', 'userId', 'driverId',
      // admin-specific keys (see AuthContext STORAGE_KEYS) — must also be cleared
      // or stale roles/permissions survive an expired session
      'adminRefreshToken', 'adminRoleKeys', 'adminPermissions', 'adminMfaEnabled',
    ].forEach((k) => localStorage.removeItem(k));
    const isAdmin = path.startsWith('/api/admin') || path.includes('/auth/admin');
    const loginPath = isAdmin ? '/admin/login' : '/login';
    // Only redirect if not already on a login page, and flag the reason
    if (!window.location.pathname.endsWith('/login')) {
      window.location.href = `${loginPath}?expired=1`;
    }
    throw new Error('Session expired. Please log in again.');
  }

  if (!res.ok) {
    const error = new Error(`API error ${res.status}`);
    error.status = res.status;
    try { error.body = await res.json(); } catch {}
    throw error;
  }

  const text = await res.text();
  return text ? JSON.parse(text) : null;
}
